import React, { useEffect } from 'react'

const TACOFPlusService = () => {
  useEffect(() => {
    document.title = 'Terms and Conditions of Flux Plus Service'
  }, [])

  return (
    <div style={container}>
      <h1 style={{ fontSize: 28, fontWeight: 700, marginBottom: 8, textAlign: 'center' }}>Terms and Conditions of Flux Plus Service</h1>
      <p style={{ color: '#888', marginBottom: 32, textAlign: 'left' }}>Last updated: </p>

      <p style={notice}>
        THIS DOCUMENT CONTAINS VERY IMPORTANT INFORMATION REGARDING YOUR RIGHTS AND OBLIGATIONS, AS WELL AS CONDITIONS, LIMITATIONS AND
        EXCLUSIONS THAT MIGHT APPLY TO YOU. PLEASE READ IT CAREFULLY.
      </p>
      <p style={notice}>BY SUBSCRIPTION ON FLUX APP, YOU ACCEPT AND ARE BOUND BY THESE TERMS AND CONDITIONS.</p>
      <p style={notice}>
        THESE TERMS AND CONDITIONS REQUIRE THE USE OF ARBITRATION TO RESOLVE DISPUTES, RATHER THAN JURY TRIALS.
      </p>

      <p>
        Hangzhou Furui Technology Co., Ltd. ("Flux", "we", "our", or "us") is the service provider, located at Floor 2, Building B, No.630,
        Qizhi Street, Binjiang District, Hangzhou City, Zhejiang Province, China.
      </p>
      <p style={notice}>
        YOU MAY NOT ORDER OR OBTAIN FLUX PLUS SERVICE FROM US IF YOU (A) DO NOT AGREE TO THESE TERMS, (B) ARE NOT THE OLDER OF (i) AT LEAST
        18 YEARS OF AGE OR (ii) LEGAL AGE TO FORM A BINDING CONTRACT WITH US, OR (C) ARE PROHIBITED FROM ACCESSING OR USING FLUX SERVICES
        OR FLUX APP BY APPLICABLE LAW.
      </p>

      <h2 style={sectionTitle}>1. Notice</h2>
      <p>
        FLUX Plus Service ("FLUX Plus Service", "Our Service", "This Service") is a fee-based service that offers AI-generated fortune-telling
        predictions (the "Output") based on the information you provide ("Your Input") and the methods you choose, mainly including daily
        horoscope, birth chart analysis, and meditation library.
      </p>
      <p>
        To use this Service, you need compatible hardware (such as your mobile phone), software (latest version recommended and sometimes
        required) and Internet access (at your own expense, if any). Our Services' performance may be affected by these factors.
      </p>
      <p>
        These Terms and Conditions ("Terms") shall govern your use of FLUX Plus Service. PLEASE READ THESE TERMS CAREFULLY. If you do not
        agree with these Terms, please do not use our Services.
      </p>
      <p>
        These Terms are incorporated into the Terms and Conditions of FLUX App, which also apply when you use our FLUX Plus Service.
      </p>

      <h2 style={sectionTitle}>2. Access to FLUX Plus Service</h2>
      <h3 style={subTitle}>Free Trial</h3>
      <p>
        Each user of the Flux App is eligible to try This Service for free for a limited number of times. Once the free trials are used up,
        no further free ones will be available, and no additional remedies will be provided. After the free trials end or if needed, you may
        choose to subscribe to This Service (e.g., monthly or annually, as applicable) through the Flux App.
      </p>
      <h3 style={subTitle}>Paid Subscription</h3>
      <p>
        Under a paid plan, you can use This Service without the restrictions on the number of times. If you choose to purchase a Paid
        Subscription for our FLUX Plus Service, you agree to pay the applicable charge associated with that Subscription (on annually or
        monthly basis). You are responsible for all applicable taxes. We may suspend or cancel the Paid Subscription if we do not receive a
        timely and complete payment from you.
      </p>
      <p>
        You will be asked to provide a payment method when you register for the Paid Subscription. You can access your billing information
        and payment method by signing into your account on FLUX App, where applicable. You agree that Flux may use any updated account
        information regarding your selected payment method provided by your issuing bank or applicable payment network. You agree to keep
        your billing account and contact information current at all times. Changes made to your billing account will not affect charges we
        submit to your billing account before we could reasonably act on your changes to your billing account.
      </p>
      <p>By providing Flux with a payment method, you:</p>
      <ul style={listStyle}>
        <li>represent that you are authorized to use the payment method that you provided and that any payment information you provide is true and accurate;</li>
        <li>authorize Flux to charge you for the FLUX Plus Service using your payment method; and</li>
        <li>authorize Flux to charge you for any paid feature of the FLUX Plus Service that you choose to enroll in or use.</li>
      </ul>
      <p>You may view our current FLUX Plus Service subscription prices on the corresponding pages of Flux App.</p>

      <h2 style={sectionTitle}>3. Automatic Renewal based on Paid Subscription</h2>
      <p>
        When you enroll in a Paid Subscription for FLUX Plus Service, we will AUTOMATICALLY RENEW YOUR SUBSCRIPTION AT THE END OF THE
        APPLICABLE PERIOD. In other words, we will automatically bill you from the date you subscribed to the FLUX Plus Service, and on each
        periodic renewal until cancellation.
      </p>
      <p>
        When you sign up for a Paid Subscription, you acknowledge and agree that you are authorizing recurring payment on either a monthly or
        annually basis (as applicable), and payments will be made to Flux by the method and at the recurring intervals chosen by you, until
        the Paid Subscription is terminated by you or by Flux. By authorizing recurring payments, you are authorizing Flux to process such
        payments.
      </p>
      <p>
        If you have signed up for a Paid Subscription that automatically renews on an annual basis, Flux will notify you of the pending
        renewal no later than 30 days prior to the end of the initial 12-month term (and each subsequent 12-month term). If you have signed
        up for a Paid Subscription that automatically renews on a monthly basis, we will not notify you of any pending renewals unless there
        is a change to the price of the Paid Subscription.
      </p>
      <p>
        Please note that your Paid Subscription will remain in effect until it's cancelled or terminated. If you remove a registered payment
        card or a renewal charge is rejected by your financial institution, your Paid Subscription will be terminated at the end of your
        subscription period.
      </p>
      <p>
        You may cancel your Paid Subscription at any time, with or without cause, by logging in your account via FLUX App and following the
        cancellation instruction.
      </p>
      <p style={notice}>
        YOU MUST CANCEL THE PAID SUBSCRIPTION BEFORE THE RENEWAL DATE TO AVOID BEING AUTOMATICALLY BILLED FOR THE RENEWAL.
      </p>

      <h2 style={sectionTitle}>4. No Refunds</h2>
      <p>
        If technical problems prevent or unreasonably delay delivery of FLUX Plus Service, your exclusive and sole remedy is the replacement
        of This Service, unless the Refunds are required by law.
      </p>
      <p>
        From time to time, Flux may refuse a refund request if we find evidence of fraud, refund abuse, or other manipulative behavior that
        entitles Flux to a corresponding counterclaim.
      </p>

      <h2 style={sectionTitle}>5. Changes of Service</h2>
      <h3 style={subTitle}>Price Changes</h3>
      <p>
        We reserve the right to change the prices and fees associated with FLUX Plus Service. We will provide notice of price and fee changes
        by sending a message to the email address associated with your account. Price changes will take effect at the beginning of the next
        payment interval. If you do not agree to the price or fee change, you must cancel the paid subscription (if applicable) and stop
        using the FLUX Plus Service before the change takes effect.
      </p>
      <h3 style={subTitle}>Scopes Changes</h3>
      <p>
        We may adjust the methods and scope of fortune-telling predictions that can be accessed through This Service. This is usually based
        on the consideration of service stability. When such adjustment occurs, we will inform you in advance and reserve time for you to
        adjust your usage preferences of this service as much as possible (if applicable).
      </p>

      <h2 style={sectionTitle}>6. Invoices</h2>
      <p>
        We provide invoices (the proof of purchase of This Service) to eligible users in accordance with applicable laws and per user's
        request. Please note that due to the nature of this Service, invoices are only available for natural persons. If you wish to purchase
        this Service on behalf of your entity and receive the corresponding invoice, please confirm the applicability of the personal invoice
        with the relevant personnel of your entity in advance.
      </p>

      <h2 style={sectionTitle}>7. Security and Legality of Your Content</h2>
      <p>
        Except for the technical processing necessary to provide you with this service, we do not obtain any rights to Your Content. You
        agree that we use Your Content to provide you with Flux Plus Services. You shall ensure that Your Content and your usage of Your
        Content or Flux Plus Services will not violate any of these Terms or any applicable law. You shall be solely responsible for the
        development, content, operation, maintenance, and use of Your Content.
      </p>
      <p>You represent and warrants to us that:</p>
      <ul style={listStyle}>
        <li>you or your licensors own all right, title, and interest on and to Your Content;</li>
        <li>you have all rights in Your Content necessary to grant the rights contemplated by these Terms; and</li>
        <li>
          none of Your Content or use of Your Content or Flux Plus Services will use, or encourage, promote, facilitate or instruct others
          to use, Flux Plus Services for any illegal, harmful, fraudulent, infringing or offensive use, or to transmit, store, display,
          distribute or otherwise make available content that is illegal, harmful, fraudulent, infringing or offensive.
        </li>
      </ul>
      <p>Prohibited activities or content include:</p>
      <ul style={listStyle}>
        <li>
          <strong>Illegal, Harmful or Fraudulent Activities.</strong> Any activities that are illegal, that violate the rights of others, or
          that may be harmful to others, our operations or reputation, including disseminating, promoting or facilitating child pornography,
          offering or disseminating fraudulent goods, services, schemes, or promotions, make-money-fast schemes, Ponzi and pyramid schemes,
          phishing, or pharming.
        </li>
        <li>
          <strong>Infringing content.</strong> Content that infringes or misappropriates the intellectual property or proprietary rights of
          others.
        </li>
        <li>
          <strong>Offensive content.</strong> Content that is defamatory, obscene, abusive, invasive of privacy, or otherwise objectionable,
          including content that constitutes child pornography, relates to bestiality, or depicts non-consensual sex acts.
        </li>
        <li>
          <strong>Harmful content.</strong> Content or other computer technology that may damage, interfere with, surreptitiously intercept,
          or expropriate any system, program, or data, including viruses, Trojan horses, worms, time bombs, or cancelbots.
        </li>
      </ul>
      <p>
        We may report any activity that it suspects violates any law or regulation to appropriate law enforcement officials, regulators, or
        other appropriate third parties. Our reporting may include disclosing appropriate customer information. We also may cooperate with
        appropriate law enforcement agencies, regulators, or other appropriate third parties to help with the investigation and prosecution
        of illegal conduct by providing network and systems information related to alleged violations of these Terms and/or applicable laws.
      </p>
      <p>
        If you become aware of any violation of these Terms and/or applicable laws, you shall immediately notify us and provide us with
        assistance, as requested, to stop or remedy the violation.
      </p>

      <h2 style={sectionTitle}>8. Miscellaneous</h2>
      <h3 style={subTitle}>Privacy</h3>
      <p>
        We respect your privacy and are committed to protecting it. Our Privacy Policy governs the processing of all personal data collected
        from you in connection with your order and/or use of our Services.
      </p>
      <h3 style={subTitle}>Governing Law</h3>
      <p>
        All matters arising out of or relating to these Terms are governed by and construed in accordance with the laws of People's Republic
        of China, without giving effect to any conflict of laws principles that may provide the application of the law of another
        jurisdiction.
      </p>
      <p>
        You agree all disputes arising out of or relating, in any way, to these Terms or your use of the Flux App, on an individual and
        purely bilateral, non-class/non-representative bases, shall be resolved by means of arbitration and shall be submitted exclusively
        to the China International Economic and Trade Arbitration Commission ("CIETAC") in Beijing in accordance with CIETAC rules.
      </p>
      <h3 style={subTitle}>Severability</h3>
      <p>
        If any provision of these terms is invalid, illegal, void or unenforceable, then that provision will be deemed severed from these
        terms and will not affect the validity or enforceability of the remaining provisions of these Terms.
      </p>
      <h3 style={subTitle}>Entire Agreement</h3>
      <p>
        These Terms and the Terms of Service are the final and integrated agreement between you and us on the matters contained in these
        Terms.
      </p>

      <div style={{ marginTop: 40, padding: '24px 0', borderTop: '1px solid #eee', color: '#666', fontSize: 14 }}>
        <p style={{ fontWeight: 600 }}>Hangzhou Furui Technology Co., Ltd.</p>
        <p>Floor 2, Building B, No.630, Qizhi Street, Binjiang District, Hangzhou City, Zhejiang Province, China.</p>
      </div>

      <div style={{ height: 60 }} />
    </div>
  )
}

const container = { maxWidth: 800, margin: '0 auto', padding: '40px 20px', fontFamily: 'system-ui, -apple-system, sans-serif', color: '#333', lineHeight: 1.8 }
const sectionTitle = { fontSize: 20, fontWeight: 700, marginTop: 40, marginBottom: 12, color: '#111' }
const subTitle = { fontSize: 16, fontWeight: 600, marginTop: 24, marginBottom: 8, color: '#222' }
const listStyle = { paddingLeft: 24, marginBottom: 16 }
const notice = { fontWeight: 600, textTransform: 'uppercase', marginBottom: 16 }

export default TACOFPlusService
